export default __webpack_public_path__ + "static/media/hero-image_project.c3e71078.svg";